import { useEffect, useRef } from 'react';
import { CoreAPI, useIdentity } from '../../core';
import { useScale, useStageType, useStageUnit } from '../../stage';

export const StoreListener = () => {
    const identity = useIdentity();
    const coreApi = CoreAPI(identity);

    const stageUnit = useStageUnit();
    const latestStageUnit = useRef(stageUnit);

    const scale = useScale();
    const latestScale = useRef(scale);

    const stageType = useStageType();
    const latestStageType = useRef(stageType);

    // 监听舞台单位变化
    useEffect(() => {
        if (latestStageUnit.current !== stageUnit) {
            coreApi.events.emitStageUnitChange(stageUnit);
            latestStageUnit.current = stageUnit;
        }
    }, [stageUnit]);

    // 监听缩放变化
    useEffect(() => {
        if (latestScale.current !== scale) {
            coreApi.events.emitScale(scale);
            latestScale.current = scale;
        }
    }, [scale]);

    // 监听舞台类型变化
    useEffect(() => {
        if (latestStageType.current !== stageType) {
            coreApi.events.emitStageTypeChange(stageType);
            latestStageType.current = stageType;
        }
    }, [stageType]);

    return null;
};
